(function(angular){
	'use strict';

	angular
		.module('cancelTransactionModalModule')
		.controller('CancelTransactionModalController', [
			'amount',
			'cancelType',
			'close',
			'ignoreClose',
			'investment',
			'reitInvestmentOrderGroupId',
			'reitInvestmentOrderGroupVersion',
			'newServiceLevel',
			'newInvestmentGoalSelection',
			'newRiaPlanType',
			'TransactionsFactory',
			'urlFactory',
			CancelTransactionModalFunction
		]);

	function CancelTransactionModalFunction(
		amount,
		cancelType,
		close,
		ignoreClose,
		investment,
		reitInvestmentOrderGroupId,
		reitInvestmentOrderGroupVersion,
		newServiceLevel,
		newInvestmentGoalSelection,
		newRiaPlanType,
		TransactionsFactory,
		urlFactory
	) {
		var cancelTransactionModal = this;

		cancelTransactionModal.reitInvestmentOrderGroupId = reitInvestmentOrderGroupId;
		cancelTransactionModal.reitInvestmentOrderGroupVersion = reitInvestmentOrderGroupVersion;
		cancelTransactionModal.newServiceLevel = newServiceLevel;
		cancelTransactionModal.newInvestmentGoalSelection = newInvestmentGoalSelection;
		cancelTransactionModal.newRiaPlanType = newRiaPlanType;
		cancelTransactionModal.amount = amount;
		cancelTransactionModal.investment = investment;
		cancelTransactionModal.cancelType = cancelType;

		cancelTransactionModal.cancellationWillCauseServiceLevelOnlyRollback = angular.isDefined(newServiceLevel)
			&& newServiceLevel !== 'None'
			&& !angular.isDefined(newInvestmentGoalSelection)
			&& !angular.isDefined(newRiaPlanType);

		cancelTransactionModal.cancellationWillCauseServiceLevelAndRiaPlanRollback = angular.isDefined(newServiceLevel)
			&& newServiceLevel !== 'None'
			&& angular.isDefined(newInvestmentGoalSelection)
			&& angular.isDefined(newRiaPlanType);

		cancelTransactionModal.close = close;
		cancelTransactionModal.ignoreClose = ignoreClose;
		cancelTransactionModal.isCancelImmediate = cancelTransactionModal.cancelType === 'cancel-transaction';
		cancelTransactionModal.isRefundUponSettlement = cancelTransactionModal.cancelType === 'cancel-transaction-upon-settlement';

		function getPayload() {
			return {
				reitInvestmentOrderGroupId: reitInvestmentOrderGroupId,
				reitInvestmentOrderGroupVersion: reitInvestmentOrderGroupVersion,
				amount: amount,
				investment : investment,
				cancelType : cancelType
			};
		}

		cancelTransactionModal.cancelTransaction = function() {
			TransactionsFactory.cancelTransaction(getPayload())
				.then(function(successUrl) {
					urlFactory.redirect(successUrl);
				})
				.catch(function() {
					cancelTransactionModal.formSubmitted = false;
					cancelTransactionModal.close();
				});
		};
	}

})(window.angular);
